import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import { base } from '@reown/appkit/networks';

export const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

if (!projectId) {
  console.warn('REACT_APP_WALLETCONNECT_PROJECT_ID is not set. WalletConnect will not work.');
}

export const networks = [base];

export const metadata = {
  name: 'FiNema',
  description: 'Decentralized audiovisual content platform',
  url: window.location.origin,
  icons: [`${window.location.origin}/favicon.svg`],
};

export const ethersAdapter = new EthersAdapter();
